import { render, staticRenderFns } from "./ProfitOrder.vue?vue&type=template&id=deaa65de&scoped=true&"
import script from "./ProfitOrder.vue?vue&type=script&lang=js&"
export * from "./ProfitOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProfitOrder.vue?vue&type=style&index=0&id=deaa65de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaa65de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VCard,VCardText,VCardTitle,VDataTable,VDialog,VPagination,VProgressCircular,VSheet,VSpacer,VSubheader,VTextField})
